// extracted by mini-css-extract-plugin
export var underlinedLink = "_p7-0";